<template>
  <div
    :class="[
      'bg-repeat pb-[72px] font-aktiv-grotesk-trial text-left text-2xl font-semibold not-italic px-[24px] pt-[56px] lg:px-[56px] align-top flex justify-between',
      bannerColor,
      { '!pt-[60px]': isIos },
    ]"
  >
    <div class="lg:hidden inline-flex items-center gap-[12px]">
      <div
        :class="[
          profileIconColor,
          'profile-icon mt-auto rounded-full w-[40px] h-[40px] border-white border-[2px] relative',
        ]"
      >
        <div
          v-if="isDropdownVisible"
          class="bg-black absolute rounded-full w-[36px] h-[36px] opacity-30"
        ></div>
        <button v-if="showProfilePic" @click="toggleDropdown">
          <img :src="profilePicture" class="rounded-full w-[36px] h-[36px]" />
        </button>
        <button
          v-if="!showProfilePic"
          class="text-[#FFF] text-[28px] w-[40px] h-[40px] font-family-['aktiv-grotesk-medium'] text-center leading-[28px]"
          @click="toggleDropdown"
        >
          {{ myName.charAt(0) }}
        </button>

        <div
          v-if="isDropdownVisible"
          v-click-away="removeDropdown"
          class="w-max min-w-[144px] mt-[8px] relative py-[8px] bg-white rounded-[12px] flex-col items-start drop-shadow-lg z-50"
        >
          <router-link to="/profile">
            <div
              class="flex pr-[20px] pl-[16px] py-[2px] items-center gap-[8px] self-stretch text-grey-100 text-[16px] z-50"
              data-event-tracking="gensapp-profile-viewprofile"
              @click="logEvent('gensapp-profile-viewprofile')"
            >
              <img src="../../../public/assets/icons/profile-circle.svg" />{{
                isGPCR ? $t('copy.homePage.profileDropdown.profile') : 'Profile'
              }}
            </div>
          </router-link>

          <router-link v-if="isGPCR" to="/gpcr/language">
            <div
              class="flex pr-[20px] pl-[16px] py-[2px] items-center gap-[8px] self-stretch text-grey-100 text-[16px] z-50"
            >
              <img src="../../../public/assets/icons/language-icon.svg" />{{
                $t('copy.homePage.profileDropdown.language')
              }}
            </div>
          </router-link>

          <router-link
            v-if="hasMultipleConferenceTypes(confYear, conferences)"
            :to="`${conferenceType}/conference`"
          >
            <div
              class="flex pr-[20px] pl-[16px] py-[2px] items-center gap-[8px] self-stretch text-grey-100 text-[16px] z-50"
            >
              <img src="../../../public/assets/icons/conference-icon.svg" />{{
                isGPCR ? $t('copy.homePage.profileDropdown.conference') : 'Conference'
              }}
            </div>
          </router-link>

          <div
            class="flex pr-[20px] pl-[16px] py-[2px] items-center gap-[8px] self-stretch text-[#B80A0A] text-[16px]"
            data-event-tracking="gensapp-home-logout-icon"
            data-test-id="gensapp-home-logout-icon"
            @click="openModal()"
          >
            <img src="../../../public/assets/icons/log-out-black.svg" />{{
              isGPCR ? $t('copy.homePage.profileDropdown.logout') : 'Log Out'
            }}
          </div>
        </div>
      </div>
      <div :class="[profileNameColor, 'lg:hidden text-[18px] leading-[24px]']">{{ myName }}</div>
    </div>
    <button
      v-if="hasQR"
      class="lg:hidden w-[40px] h-[40px] cursor-pointer hover:opacity-90"
      data-event-tracking="gensapp-home-buttons-myqr"
      data-test-id="gensapp-home-buttons-myqr"
      @click="showQR()"
    >
      <img :src="qrIcon" class="w-full h-full" alt="My QR" />
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { hasMultipleConferenceTypes } from '@/utils/conference-type';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import { mixin as clickaway } from 'vue3-click-away';
import platformMixin from '@/mixins/platformMixin';

export default {
  name: 'ProfileNav',
  mixins: [clickaway, platformMixin],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    hasQR: {
      type: Boolean,
      default: false,
    },
    qrIcon: {
      type: String,
      default: '/assets/icons/home-qr.svg',
    },
    bannerColor: {
      type: String,
      default: 'bg-yellow-bar',
    },
    profileNameColor: {
      type: String,
      default: '',
    },
    profileIconColor: {
      type: String,
      default: 'bg-lightblue',
    },
    conferenceType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDropdownVisible: false,
    };
  },
  computed: {
    ...mapGetters('profile', ['name']),
    ...mapState('profile', ['confYear', 'conferences']),
    ...mapState('social', ['profilePicture']),
    ...mapState('social', {
      displayName: 'name',
    }),
    showProfilePic() {
      return this.profilePicture;
    },
    myName() {
      return this.displayName ? this.displayName : this.name;
    },
    isGPCR() {
      return this.conferenceType.includes('gpcr');
    },
  },
  methods: {
    hasMultipleConferenceTypes,
    async logEvent(event) {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: event,
          page: 'home',
        },
      });
    },
    openModal() {
      this.isDropdownVisible = false;
      this.$emit('update:showModal', true);
    },
    removeDropdown() {
      this.isDropdownVisible = false;
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    showQR() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'gensapp-home-buttons-myqr',
          page: 'home',
        },
      });
      this.$router.push('/qr-code');
    },
  },
};
</script>
